module.exports = __webpack_public_path__ + "static/img/qiye1.3ea6dffe.png";